var uId = 1;

var uniqueId = function uniqueId() {
  return uId++;
},
    root = "object" == typeof self && self.self == self ? self : "object" == typeof global && global.global == global ? global : {},
    nowOffset = Date.now(),
    pnow = function pnow() {
  return root.performance && "function" == typeof root.performance.now ? root.performance.now() : Date.now() - nowOffset;
};

var reservedCBs = {},
    lastTime = Date.now();

var polyfillRaf = function polyfillRaf(e) {
  if ("function" != typeof e) throw new TypeError(e + " is not a function");
  var o = Date.now(),
      t = o - lastTime,
      n = t > 16 ? 0 : 16 - t,
      r = uId++;
  return reservedCBs[r] = e, Object.keys(reservedCBs).length > 1 || setTimeout(function () {
    lastTime = o;
    var e = reservedCBs;
    reservedCBs = {}, Object.keys(e).forEach(function (o) {
      return e[o](root.performance && "function" == typeof root.performance.now ? root.performance.now() : Date.now() - nowOffset);
    });
  }, n), r;
},
    polyfillCaf = function polyfillCaf(e) {
  delete reservedCBs[e];
},
    vendorPrefixes = ["", "webkit", "moz", "ms", "o"],
    getRequestAnimationFrame = function getRequestAnimationFrame(e) {
  return "string" != typeof e ? polyfillRaf : "" === e ? root.requestAnimationFrame : root[e + "RequestAnimationFrame"];
},
    getCancelAnimationFrame = function getCancelAnimationFrame(e) {
  return "string" != typeof e ? polyfillCaf : "" === e ? root.cancelAnimationFrame : root[e + "CancelAnimationFrame"] || root[e + "CancelRequestAnimationFrame"];
},
    find = function find(e, o) {
  var t = 0;

  for (; void 0 !== e[t];) {
    if (o(e[t])) return e[t];
    t += 1;
  }
},
    vp = find(vendorPrefixes, function (e) {
  return !!getRequestAnimationFrame(e);
}),
    raf = getRequestAnimationFrame(vp),
    caf = getCancelAnimationFrame(vp);

root.requestAnimationFrame = raf, root.cancelAnimationFrame = caf, "undefined" != typeof module && module.exports && (module.exports = {
  requestAnimationFrame: raf,
  cancelAnimationFrame: caf
});
var index = {
  requestAnimationFrame: raf,
  cancelAnimationFrame: caf
};
export default index;
export { caf as cancelAnimationFrame, raf as requestAnimationFrame };